export const WORK_ITEMS = [
  { key: 'apprenticeship', labelId: 'experience.form.apprenticeshipType' },
  { key: 'employment', labelId: 'experience.form.employmentType' },
  { key: 'internship', labelId: 'experience.form.internshipType' },
];

export const CREDENTIAL_TYPE_ITEMS = [
  { key: 'assessment', labelId: 'experience.form.assessmentType' },
  { key: 'badge', labelId: 'experience.form.badgeType' },
  { key: 'course', labelId: 'experience.form.courseType' },
  { key: 'certificate', labelId: 'experience.form.certificateType' },
  { key: 'certification', labelId: 'experience.form.certificationType' },
  { key: 'license', labelId: 'experience.form.licenseType' },
  { key: 'apperenticeshipRTI', labelId: 'experience.form.apprenticeshipRTIType' },
];
